import { storiesOf } from '@storybook/vue';
import { withKnobs, boolean, text } from '@storybook/addon-knobs';

const stories = storiesOf('Components/DMS/Form', module);

stories
	.addDecorator(withKnobs)
	.add('Info Button', () => ({
		template: `
			<div>
				<el-row>
					<dms-input :span="2">plain text</dms-input>
					<dms-info-button v-bind="{text,title}"/>
				</el-row>
			</div>
		`,
		props: {
			disabled: {
				default: boolean('Disabled', false),
			},
			title: {
				default: text('plainLabel', 'title'),
			},
			text: {
				default: text('plainText', 'text'),
			},
		},
	}));
